import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.currentPassword) newErrors.currentPassword = 'Current password is required';
    if (!formData.newPassword) newErrors.newPassword = 'New password is required';
    if (formData.newPassword !== formData.confirmPassword)
      newErrors.confirmPassword = 'Passwords do not match';
    if (formData.newPassword && !isPasswordStrong(formData.newPassword))
      newErrors.newPassword = 'Password must be at least 8 characters, contain a number, and an uppercase letter';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isPasswordStrong = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateForm()) return;
  
    setIsSubmitting(true);
    const authToken = sessionStorage.getItem('authToken');
  
    try {
      const response = await fetch(`${BaseUrl}/change-individual-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
  
      const responseData = await response.json();
  
      if (response.status === 200) {
        toast.success('Password changed successfully');
        navigate('/dashboard');
      } else {
        toast.error(responseData.error || 'Failed to change password');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred while changing the password');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="auth-right py-32 px-6 d-flex flex-column justify-content-center">
      <div className="max-w-lg mx-auto w-100">
        <h5 className="text-center mb-12">Change Password</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="currentPassword" className="form-label">Current Password</label>
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              className="form-control h-56-px bg-neutral-50 radius-12"
              placeholder="Current Password"
              required
            />
            {errors.currentPassword && <div className="text-danger">{errors.currentPassword}</div>}
          </div>

          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label">New Password</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              className="form-control h-56-px bg-neutral-50 radius-12"
              placeholder="New Password"
              required
            />
            {errors.newPassword && <div className="text-danger">{errors.newPassword}</div>}
          </div>

          <div className="mb-3">
            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="form-control h-56-px bg-neutral-50 radius-12"
              placeholder="Confirm Password"
              required
            />
            {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
          </div>

          <button
            type="submit"
            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Changing...' : 'Continue'}
          </button>
        </form>
      </div>
                <ToastContainer position="top-right" autoClose={3000} />
      
    </div>
  );
};

export default ChangePassword;
